import { ConfirmationModal } from '@/components';
import { getOrderStatusOptions } from '../../helpers';
import { useTranslation } from 'react-i18next';
import { OrderStatus } from '@/models/order.model';
import { Select } from '@/ui';
import { useState } from 'react';

type TChangeOrderStatusProps = {
  value?: OrderStatus | null;
  loading?: boolean;
  onChange?: (status: OrderStatus) => void;
};

const ChangeOrderStatus = ({ loading, value, onChange }: TChangeOrderStatusProps) => {
  const { t } = useTranslation('order');
  const [status, setStatus] = useState<OrderStatus | null>(null);

  const handleChangeStatus = () => {
    if (!status) return;
    setStatus(null);
    return onChange?.(status);
  };

  const handleCancel = () => setStatus(null);

  return (
    <>
      <Select<OrderStatus, OrderStatus>
        options={getOrderStatusOptions(t)}
        value={value}
        loading={loading}
        disabled={[OrderStatus.COMPLETED, OrderStatus.CANCELED].includes(value ?? OrderStatus.CANCELED)}
        size="large"
        onChange={setStatus}
      />
      <ConfirmationModal
        title={t('title_change_status', {
          context: status,
        })}
        isOpened={!!status}
        onConfirm={handleChangeStatus}
        onCancel={handleCancel}
        okText={t('button_change_status')}
        cancelText={t('button_cancel')}
      />
    </>
  );
};

export default ChangeOrderStatus;
